export default __webpack_public_path__ + "static/media/datatrack.b227e443.gif";